export default "__VITE_ASSET__BQp4m5U9__"